import apiExpenseItem from '@/api/expense-item'
export default [
  {
    path: '/expense-items',
    name: 'expense-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/expense-item/index.vue')
  },
  {
    path: '/expense-items/:id',
    name: 'expense-item-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/expense-item/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiExpenseItem.find(to.params.id)
      to.params.editData = response.data
      next()
    }
  }
]
